import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Container } from '../../ui'
import { openWindow } from '../../models/window/actions'
import { modalNames } from '../common/modal/constants/names'
import { subscriptions } from '../../constants/subscriptions'
import {numberWithSpaces} from "../../core/helpers/number-with-spaces";

import Form from './form'

import c from './assets/sass/tickets.module.scss'

const Tickets = () => {
    const dispatch = useDispatch()

    const [selectedCategory, setSelectedCategory] = useState(subscriptions[0])
    const [selectedSubscription, setSelectedSubscription] = useState(
        subscriptions[0].items[0]
    )

    const bookHandler = () => {
        dispatch(openWindow(modalNames.CONTACT_MODAL))
    }

    const categoryHandler = (category) => {
        setSelectedCategory(category)
        setSelectedSubscription(category.items[0])
    }

    const subscriptionHandler = (subscription) => {
        setSelectedSubscription(subscription)
    }

    return (
        <section id="tickets" className={c.component}>
            <div className={c.title}>
                <div className={c.subtitle}>Специальные Предложения</div>
                <div className={c.titleText}>Абонементы</div>
            </div>

            <div className={c.listRow}>
                <div className={c.listWrapper}>
                    <ul className={c.tabs}>
                        {subscriptions.map((category) => (
                            <li key={category.id}>
                                <button
                                    className={c.tabsButton}
                                    onClick={() => categoryHandler(category)}
                                >
                                    <div className={c.tabsButtonText}>
                                        {category.title}
                                    </div>

                                    <div className={c.tabsButtonCounter}>
                                        {category.items.length}
                                    </div>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <Form
                categories={subscriptions}
                selectedCategory={selectedCategory}
                selectedSubscription={selectedSubscription}
                onCategoryChange={categoryHandler}
                onSubscriptionChange={subscriptionHandler}
            />

            <Container>
                <div className={c.bottom}>
                    <div>
                        {selectedSubscription.oldPrice > 0 && (
                            <div className={c.oldPrice}>
                                {numberWithSpaces(selectedSubscription.oldPrice)} ₽
                            </div>
                        )}

                        <div className={c.newPrice}>
                            {selectedSubscription.price}

                            {selectedSubscription.saving && (
                                <div className={c.discount}>
                                    -{selectedSubscription.saving}
                                </div>
                            )}
                        </div>
                    </div>

                    <button
                        className={c.button}
                        onClick={bookHandler}
                    >
                        Приобрести
                    </button>
                </div>
            </Container>
        </section>
    )
}

export default Tickets
